module.exports = __webpack_public_path__ + "img/nature-book.7c8030d9.jpeg";